import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LoginScreen from './screens/LoginScreen';
import AdminLayout from './screens/AdminLayout';
import ServicesPage from './screens/ServicesPage';
import TemplatesPage from './screens/TemplatesPage';
import MasterAHASSPage from './screens/MasterAHASSPage';
import MasterBikesPage from './screens/MasterBikesPage';
import MasterSparePartsPage from './screens/MasterSparePartsPage';
import GlobalMasterSparePartsPage from './screens/GlobalMasterSparePartsPage';
import MasterBikePartsPage from './screens/MasterBikePartsPage';
import UsersPage from './screens/UsersPage';
import MasterCustomersPage from './screens/MasterCustomersPage';
import MasterStocksPage from './screens/MasterStocksPage';
import PromotionGroups from './screens/PromotionGroups';
import ProfilePage from './screens/ProfilePage';

function App() {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    const token = localStorage.getItem('token');

    if (savedUser && token) {
      const parsedUser = JSON.parse(savedUser);
      if (['superadmin', 'admin'].includes(parsedUser.role)) {
        setUser(parsedUser);
      } else {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
      }
    }
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="animate-pulse flex flex-col items-center">
          <div className="w-12 h-12 bg-blue-200 rounded-full mb-4"></div>
          <p className="text-gray-400 font-medium">Initializing...</p>
        </div>
      </div>
    );
  }

  const handleLoginSuccess = (userData) => setUser(userData);
  const handleLogout = () => setUser(null);

  return (
    <BrowserRouter>
      <Routes>
        {/* Login route */}
        <Route
          path="/login"
          element={
            user ? (
              <Navigate to="/services" replace />
            ) : (
              <LoginScreen onLoginSuccess={handleLoginSuccess} />
            )
          }
        />

        {/* Protected admin routes */}
        <Route
          path="/"
          element={<AdminLayout user={user} onLogout={handleLogout} />}
        >
          <Route index element={<Navigate to="/services" replace />} />
          <Route path="services" element={<ServicesPage user={user} />} />
          <Route path="templates" element={<TemplatesPage />} />
          <Route path="master-ahass" element={<MasterAHASSPage user={user} />} />
          <Route path="master-bikes" element={<MasterBikesPage user={user} />} />
          <Route path="master-spare-parts" element={<MasterSparePartsPage user={user} />} />
          <Route path="global-master-spare-parts" element={<GlobalMasterSparePartsPage user={user} />} />
          <Route path="master-bike-parts" element={<MasterBikePartsPage user={user} />} />
          <Route path="master-users" element={<UsersPage user={user} />} />
          <Route path="master-customers" element={<MasterCustomersPage user={user} />} />
          <Route path="master-stocks" element={<MasterStocksPage user={user} />} />
          <Route path="promotion-groups" element={<PromotionGroups user={user} />} />
          <Route path="profile" element={<ProfilePage user={user} onUpdateUser={(u) => setUser(u)} />} />
          {/* Fallback */}
          <Route path="*" element={<Navigate to="/services" replace />} />
        </Route>

        {/* Root fallback */}
        <Route
          path="*"
          element={<Navigate to={user ? '/services' : '/login'} replace />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
